import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { Chart, ChartConfiguration, Color } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { LocaldataService } from '../../../service/localdata/localdata.service';

import { AnalyticsResponse } from './chart-data.interface';
//import { createChartAvg, createChartRecent, createChartDetails } from './chart-utils';
import { FormattingService } from '../../../service/formatting/formatting.service';

import { BaseChartDirective } from 'ng2-charts';
import { callback } from 'chart.js/dist/helpers/helpers.core';

@Component({
  selector: 'app-vejebon',
  templateUrl: './vejebon.page.html',
  styleUrls: ['./vejebon.page.scss'],
})
export class VejebonPage implements OnInit {
  public chartLabels = ['Stivelse', 'Smuds', 'Sten'];
  public chartColours = ['#009ABD', '#00e676', '#ff5722'];
  public borderWidth = 0.5;
  public borderColor = '#ddd';
  public chartXAxis = ['Dit kampagne gennemsnit', "AKD's kampagne gennemsnit"];

  public weighinId: string;
  public weighinSerialnumber: string;
  analyticsData: AnalyticsResponse;
  error: string;


  public chartDetails: any;

  public chartRecent: any;

  public chartAvg: any;


  public jsonObj: [];

  public totalAmount: number;
  public displayPercentage: number = 0;
  public displayPercentageOpacity: number = 0;
  public animated: boolean = false;

  // Add a reference for each chart
  private chartDetailsInstance;
  private chartRecentInstance;
  private chartAvgInstance;


  public counter=0;


  public AddLegendPadding = {
    id: '1',
    beforeInit(chart) {
      const originalFit = chart.legend.fit;
      chart.legend.fit = function fit() {
        originalFit.bind(chart.legend)();
        this.height += 10;
      };
    }
  };


  public barChartLegendDetails = true;
  public barChartPluginsDetails = [ChartDataLabels, this.AddLegendPadding];
  public barChartDataDetails: ChartConfiguration<'bar'>['data'] = {
    labels: this.chartLabels,
    datasets: []
  };
  public barChartOptionsDetails: ChartConfiguration<'bar'>['options'] = {
    responsive: false,

  };


  public barChartLegendRecent = true;
  public barChartPluginsRecent = [ChartDataLabels, this.AddLegendPadding];
  public barChartDataRecent: ChartConfiguration<'bar'>['data'] = {
    labels: this.chartLabels,
    datasets: []
  };
  public barChartOptionsRecent: ChartConfiguration<'bar'>['options'] = {
    responsive: false,
  };

  public barChartLegendAvg = true;
  public barChartPluginsAvg = [ChartDataLabels, this.AddLegendPadding];
  public barChartDataAvg: ChartConfiguration<'bar'>['data'] = {
    labels: this.chartLabels,
    datasets: []
  };
  public barChartOptionsAvg: ChartConfiguration<'bar'>['options'] = {
    responsive: false,
  };



  constructor(private route: ActivatedRoute, private localData: LocaldataService, private datePipe: DatePipe, private formattingService: FormattingService, private router: Router) { }


  
  ngOnDestroy() {
  
    /*if (this.chartDetailsInstance) {
      this.chartDetailsInstance.destroy();
      this.chartDetailsInstance = null;
    }
    if (this.chartRecentInstance) {
      this.chartRecentInstance.destroy();
      this.chartRecentInstance = null;
    }
    if (this.chartAvgInstance) {
      this.chartAvgInstance.destroy();
      this.chartAvgInstance = null;
    }*/
  }
  ionViewDidEnter() {  // Using Ionic's lifecycle event
    
    //Chart.defaults
    //console.log('ionViewDidEnter called', Chart.instances);


    /*if (this.chartDetailsInstance) {
      //console.log('Destroying chartDetailsInstance');
      this.chartDetailsInstance.destroy();
    }
    if (this.chartRecentInstance) {
      //console.log('Destroying chartRecentInstance');
      this.chartRecentInstance.destroy();
    }
    if (this.chartAvgInstance) {
      //console.log('Destroying chartAvgInstance');
      this.chartAvgInstance.destroy();
    }*/

    this.weighinId = this.route.snapshot.params['id'];
    this.weighinSerialnumber = this.route.snapshot.queryParams['serialnumber'];

    //console.log(`Fetching data for weighinId: ${this.weighinId}, weighinSerialnumber: ${this.weighinSerialnumber}`);

    this.fetchVejebonData(this.weighinId);
    this.fetchAnalyticsData();


    
  }


  
  ngOnInit() {

    //this.createChartDetailsDetails()
  }




  getCommonBarChartOptions(title: string): any {
    return {
      maintainAspectRatio: false,
      plugins: {
        title: {
          text: title,
          display: true
        },
        datalabels: {
          color: '#000000',
          textAlign: 'center',
          font: {
            lineHeight: 1.6
          },
         
        display: 'auto',
        formatter: (value, ctx) => {console.log('FORMAT')
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map(data => {
            sum += data;
          });
          let percentage = (value * 100 / sum).toFixed(2) + "%";
          return percentage;
        }
        },
        tooltip: {
          enabled: false
        }
      },
      scales: {
        x: {
            ticks: {
              /*callback: function(value, index, ticks) {
                console.log(labels[index]);
                if (/\s/.test(labels[index])) {
                  return labels[index].split(" ");
                }else{
                  return labels[index];
                }       
              }*/
            },
            stacked: true,
            display: true,   
          },
          y: {
            stacked: true,
            display: false,          
          }
      }
    };
  }


  createChartAvgAvg(data: any, config: any){

    let ChartData = data;

    const { chartLabels, chartXAxis, chartColours, borderWidth, borderColor } = config;
    let labels = chartXAxis;
  
    let compositionDataStarch = ChartData.map(item => {
      const key = Object.keys(item)[0];
      return item[key].avgstarch;
    });
    let compositionDataDirt = ChartData.map(item => {
      const key = Object.keys(item)[0];
      return item[key].avgdirt;
    });
    let compositionDataStone = ChartData.map(item => {
      const key = Object.keys(item)[0];
      return item[key].avgstone;
    });

    

    let receiptIDs =  ChartData.map(key => key.serialnumber);
  
      this.barChartLegendAvg = true;
      this.barChartPluginsAvg = [];
      
      this.barChartDataAvg = {
        labels: labels,
        datasets: [
          {
          label: chartLabels[0],
          data: compositionDataStarch,
          backgroundColor: chartColours[0],
          borderWidth: borderWidth,
          borderColor: borderColor
        },
        {
          label: chartLabels[1],
          data: compositionDataDirt,
          backgroundColor: chartColours[1],
          borderWidth: borderWidth,
          borderColor: borderColor
        },
        {
          label:chartLabels[2],
          data: compositionDataStone,
          backgroundColor: chartColours[2],
          borderWidth: borderWidth,
          borderColor: borderColor
        }
      ]
      }
  
      this.barChartPluginsAvg = [ChartDataLabels];
    
      this.barChartOptionsAvg = {
        
        responsive: true,
        maintainAspectRatio: false,
        
        plugins: {
          title: {
            text: 'Kampagnegennemsnit',
            display: true
          },
          datalabels: {
            color: '#000000',
            textAlign: 'center',
            font: {
              lineHeight: 1.6
            },
            display: true,
            formatter: (value, ctx) => {
              //const label = ctx.chart.data.labels[ctx.dataIndex];
              return `${Math.round(value * 10) / 10}%`;;
            }
          },
          tooltip: {
            enabled: false
          },
        },
        scales: {
          x: {
              stacked: true,
              display: true,
              ticks: {
                callback: function(value, index, ticks) {
                  if (/\s/.test(labels[index])) {
                    return labels[index].split(" ");
                  }else{
                    return labels[index];
                  }       
                }
              }
            },
            y: {
              stacked: true,
              display: false,          
            },
        }        
      };
    }

  createChartRecentRecent(data: any, config: any){

    let ChartData = data;
    const { chartLabels, chartColours, borderWidth, borderColor } = config;
  
    let compositionDataStarch = ChartData.map(key => key.starch);
    let compositionDataDirt = ChartData.map(key => key.dirt);
    let compositionDataStone = ChartData.map(key => key.stone);

    let receiptIDs =  ChartData.map(key => key.serialnumber);
  
      this.barChartLegendRecent = true;
      this.barChartPluginsRecent = [];

      
      this.barChartDataRecent = {
        labels: receiptIDs,
        datasets: [
          {
            label: chartLabels[0],
            data: compositionDataStarch,
            backgroundColor: chartColours[0],
            borderWidth: borderWidth,
            borderColor: borderColor
          },
          {
            label: chartLabels[1],
            data: compositionDataDirt,
            backgroundColor: chartColours[1],
            borderWidth: borderWidth,
            borderColor: borderColor
          },
          {
            label: chartLabels[2],
            data: compositionDataStone,
            backgroundColor: chartColours[2],
            borderWidth: borderWidth,
            borderColor: borderColor
          }
          
        ]
      }
  
      this.barChartPluginsRecent = [ChartDataLabels];
    
      this.barChartOptionsRecent = {
        
        responsive: true,
        maintainAspectRatio: false,
        
        plugins: {
          title: {
            text: 'Dine seneste indvejninger',
            display: true
          },
          datalabels: {
            color: '#000000',
            textAlign: 'center',
            font: {
              lineHeight: 1.6
            },
            display: true,
            formatter: (value, ctx) => {
              const label = ctx.chart.data.labels[ctx.dataIndex];
              return `${Math.round(value * 10) / 10}%`;;
            }
          },
          tooltip: {
            enabled: false
          },
        },
        scales: {
          x: {
              stacked: true,
              display: true,   
            },
            y: {
              stacked: true,
              display: false,          
            }
        },
        
      };
    }

  createChartDetailsDetails(data: any, config: any){

  let ChartData = data;
  const { chartLabels, chartColours, borderWidth, borderColor } = config;

  let compositionDataStarch = ChartData.starch;
  let compositionDataDirt = ChartData.dirt;
  let compositionDataStone = ChartData.stone;

    this.barChartLegendDetails = true;
    this.barChartPluginsDetails = [];
    this.barChartDataDetails = {
      labels: config.chartLabels,
      datasets: [
        {
          data: [compositionDataStarch, compositionDataDirt, compositionDataStone],
          backgroundColor: chartColours
        }
      ]
    }

    this.barChartPluginsDetails = [ChartDataLabels];
  
    this.barChartOptionsDetails = {
      responsive: false,
      maintainAspectRatio: true,
      
      plugins: {
        title: {
          text: 'Det aktuelle læs',
          display: true
        },
        datalabels: {
          color: '#000000',
          textAlign: 'center',
          font: {
            lineHeight: 1.6
          },
          display: true,
          formatter: (value, ctx) => {
            const label = ctx.chart.data.labels[ctx.dataIndex];
            return `${label} \n ${Math.round(value * 10) / 10}%`;;
          }
        },
        tooltip: {
          enabled: false
        },
      },
      scales: {
        x: {
            stacked: true,
            display: false,   
          },
          y: {
            stacked: true,
            display: false,          
          }
      },
      
    };
  }

  fetchAnalyticsData(): void {

    let user_token: string = localStorage.getItem('access_token') || '{}';
    let profileStr: string | null = localStorage.getItem('profile');
    let user_id: string | null = profileStr ? JSON.parse(profileStr).id : null;

    this.localData.fetchAnalyticsData(this.weighinId, user_id, '105', this.weighinSerialnumber).subscribe(
      data => {
        this.analyticsData = data;
        // Configuration for each chart type
        const avgConfig = {
          chartLabels: this.chartLabels,
          chartXAxis: this.chartXAxis,
          chartColours: this.chartColours,
          borderWidth: this.borderWidth,
          borderColor: this.borderColor
        };

        const recentConfig = {
          chartLabels: this.chartLabels,
          chartColours: this.chartColours,
          borderWidth: this.borderWidth,
          borderColor: this.borderColor
        };

        const detailsConfig = {
          chartLabels: this.chartLabels,
          chartColours: this.chartColours,
          borderWidth: this.borderWidth,
          borderColor: this.borderColor
        };


        this.createChartDetailsDetails(data.currentWeighin.data, detailsConfig);

        
        this.createChartRecentRecent(data.comparisonFarmer.data, recentConfig);


        this.createChartAvgAvg(data.comparisonCampaign.data, avgConfig);

/*
        // Destroy the previous chart instance if it exists
        if (this.chartDetailsInstance) {
          this.chartDetailsInstance.destroy();
        }
        this.chartDetailsInstance = createChartDetails(data.currentWeighin.data, detailsConfig);

        // Do the same for the other charts
        if (this.chartRecentInstance) {
          this.chartRecentInstance.destroy();
        }
        this.chartRecentInstance = createChartRecent(data.comparisonFarmer, recentConfig);

        if (this.chartAvgInstance) {
          this.chartAvgInstance.destroy();
        }
        this.chartAvgInstance = createChartAvg(data.comparisonCampaign, avgConfig);
        this.chartAvgInstance.update();
      */
      },
      error => {
        this.error = "There was an issue loading the chart data. Please try again later.";
      }
    );
  }

  fetchVejebonData(weighinId: string): void {
    this.localData.fetchVejebonData(weighinId).subscribe(
      data => {
        //data.timestamp = DateFormatComponent(timeStamp);
        //console.log('DATA', data)
        data.starch = Math.round(data.starch * 10) / 10;
        data.stone = Math.round(data.stone);
        data.dirt = Math.round(data.dirt);
        //console.log('DATA', data)
        this.jsonObj = data;
        this.totalAmount = Number(data.delivered_total_corrected) + Number(data.remaining_total_starch_corrected);
        
        setTimeout(() => {
          this.displayPercentage = Math.round(Number(data.delivered_total_corrected) / this.totalAmount*1000)/10;
          this.displayPercentageOpacity = 1;
          this.animated = true;
        }, 100);

      },
      error => {
        this.error = "There was an issue loading the chart data. Please try again later.";
      }
    );
  }
  getFormattedSerialnumber(serialnumber: string): string {
    return `Løbenummer: ${serialnumber}`;
  }

  getFormattedDate(dateStr: string): string {
    let date = this.datePipe.transform(dateStr, 'dd-MM-yy');
    let time = this.datePipe.transform(dateStr, 'HH.mm');
    return `${date} Kl. ${time}`;
  }

  openExternalBrowser(url:string){
    let path: string = 'https://kartoffeludbytte.dlbr.dk/Bon?nummer=' + url;
    window.open(path, '_system', 'location=tye');
  }


}